import React from "react";
import FamiliesCaring1 from "../assets/images/familycaring1.png";
import FamiliesCaring2 from "../assets/images/familycaring2.jpg";
import DoubleTick from "../assets/icons/doubletick.svg";

export default function CaringFromMiles() {
  return (
    <div className="caringFromMiles_container">
      <div className="caringFromMiles_contentWrapper">
        {/* Left Section */}
        <div className="caringFromMiles_left">
          <img
            src={FamiliesCaring1}
            alt="Doctor consultation"
            className="caringFromMiles_mainImage"
          />

          {/* Optional overlay image (commented as in original) */}
          {/*
          <div className="caringFromMiles_overlayImageWrapper">
            <img
              src={FamiliesCaring2}
              alt="Family support"
              className="caringFromMiles_overlayImage"
            />
          </div>
          */}
        </div>

        {/* Right Section */}
        <div className="caringFromMiles_right">
          <h2 className="caringFromMiles_title">
            Caring From Miles Away, Without Worry
          </h2>

          <p className="caringFromMiles_paragraph">
            As a professional living abroad, you’ve worked hard to give your
            parents the best—security, comfort, and dignity. Yet, when it comes
            to their healthcare back home, you may have felt the weight of
            worry:
          </p>

          {/* List */}
          <ul className="caringFromMiles_list">
            {[
              "Will they truly receive the care they deserve?",
              "Who will communicate with me promptly and honestly?",
              "Can I trust the service to meet the standards I’m accustomed to?",
            ].map((text, index) => (
              <li key={index} className="caringFromMiles_listItem">
                <img
                  src={DoubleTick}
                  alt="check"
                  className="caringFromMiles_icon"
                />
                <span className="caringFromMiles_listText">{text}</span>
              </li>
            ))}
          </ul>

          <p className="caringFromMiles_paragraph">
            At VeriMED, we understand these questions because we’ve been there
            ourselves. We know the unique mix of love, responsibility, and
            concern that comes with caring for aging parents from thousands of
            miles away.
          </p>

          {/* Optional button if needed */}
          {/* <SecondaryBtn label="Learn More" /> */}
        </div>
      </div>
    </div>
  );
}
